$(document).ready(function() {
    // Зберігаємо оригінальні параметри запиту з кнопки Load More
    var originalVars = $('.load-more-slots').attr('data-vars');

    // Обробка кліку на "Load More"
    $(document).on('click', '.load-more-slots', function(){
        let $btn = $(this);
        if ($btn.hasClass('loading')) return;
        $btn.addClass('loading');

        let currentPage = parseInt($btn.attr('data-current')) || 1,
            maxPages = parseInt($btn.attr('data-max')) || 1,
            vars = originalVars,
            text_more = $btn.attr('data-text-more') || 'Load More',
            text_less = $btn.attr('data-text-less') || 'Load Less',
            text_loading = $btn.attr('data-text-loading') || 'Loading...';

        let data = {
            action: 'loadmore_slots',
            page: currentPage + 1,
            query: vars
        };

        $.ajax({
            type: 'POST',
            url: additional_params.ajaxactionurl,
            data: data,
            beforeSend: function() {
                $btn.text(text_loading);
            },
            success: function(response){
                if(response){
                    $('.slots_list').append(response);
                    currentPage++;
                    $btn.attr('data-current', currentPage);

                    if(currentPage >= maxPages){
                        $btn.replaceWith(`<div class="remove-slots btn btn__red" data-text-less="${text_less}" data-text-more="${text_more}" data-current="1" data-max="${maxPages}" data-vars='${vars}'>${text_less}</div>`);
                    } else {
                        $btn.removeClass('loading');
                        $btn.text(text_more);
                    }
                } else {
                    $btn.remove();
                }
            },
            error: function(xhr, status, error) {
                console.error("AJAX Error:", error);
                $btn.removeClass('loading');
                $btn.text("Error");
            }
        });
    });

    // Обробка кліку на "Show Less"
    $(document).on('click', '.remove-slots', function(){
        let $btn = $(this),
            initialPosts = $(window).width() < 768 ? 4 : 6,
            data_max = $btn.attr('data-max'),
            data_vars = originalVars,
            text_more = $btn.attr('data-text-more') || 'Load More',
            text_less = $btn.attr('data-text-less') || 'Load Less',
            text_loading = $btn.attr('data-text-loading') || 'Loading...';

        $('.slots_list .slot-card').slice(initialPosts).remove();
        $btn.replaceWith(`<div class="load-more-slots btn btn__red" data-current="1" data-max="${data_max}" data-vars='${data_vars}' data-text-more="${text_more}" data-text-less="${text_less}" data-text-loading="${text_loading}">${text_more}</div>`);
    });
});
